import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './portraitViewMessageActions';

export const initialState = {
    portraitMsg: true
}

export default handleActions({
    [actions.enablePortraitViewMessage]: ( state, action ) => u({
        portraitMsg: true
    }, state),
    [actions.disablePortraitViewMessage]: ( state, action ) => u({ portraitMsg: false }, state ),
}, initialState);




// WEBPACK FOOTER //
// ./src/redux/portraitViewMessageReducer.js